const GOOGLE_USER_CONTENT_PREFIX = "https://lh3.googleusercontent.com";
const AVATAR_URL_LENGTH_THRESHOLD = 200;

export function sanitizeAvatar(avatar: string | null): string | null {
    if (
        avatar !== null &&
        avatar.length > AVATAR_URL_LENGTH_THRESHOLD &&
        avatar.startsWith(GOOGLE_USER_CONTENT_PREFIX)
    ) {
        return null;
    }
    return avatar;
}
